(function () {
  var CM_SEARCH_URL = "https://oewholesale1.myconvermax.com/search.json";

  function buildFacetUrl(fields) {
    var url = new URL(CM_SEARCH_URL);
    url.searchParams.set("pagesize", "0");

    fields.forEach(function (field, index) {
      url.searchParams.set("facet." + index + ".field", field.name);
      if (field.selection) {
        url.searchParams.set("facet." + index + ".selection", field.selection);
      }
    });

    return url.toString();
  }

  function findFacet(facets, fieldName) {
    return (facets || []).find(function (facet) {
      return facet.FieldName === fieldName;
    });
  }

  function clearSelect(select, placeholder) {
    select.innerHTML = "";

    var option = document.createElement("option");
    option.className = "default";
    option.value = "";
    option.selected = true;
    option.disabled = true;
    option.textContent = placeholder;
    select.appendChild(option);
  }

  function disableSelect(select, placeholder) {
    clearSelect(select, placeholder);
    select.disabled = true;
    var group = select.closest(".form-group");
    if (group) group.classList.add("disabled");
  }

  function enableSelect(select) {
    select.disabled = false;
    var group = select.closest(".form-group");
    if (group) group.classList.remove("disabled");
  }

  function populateSelect(select, values) {
    values.forEach(function (value) {
      var option = document.createElement("option");
      option.value = value.Value;
      option.textContent = value.Value;
      option.dataset.term = value.Term || value.Value;
      select.appendChild(option);
    });
  }

  function setSelectValueByTerm(select, term) {
    var match = Array.prototype.slice.call(select.options).find(function (option) {
      return option.dataset.term === term;
    });
    if (!match) return false;

    select.value = match.value;
    return true;
  }

  function parseVehicleFromUrl() {
    var raw = window.location.search.replace(/^\?/, "");
    if (!raw) return null;

    var segments = raw.split("/").map(decodeURIComponent);
    var vehicle = {};

    segments.forEach(function (segment, index) {
      if (segment === "Year") vehicle.year = segments[index + 1];
      if (segment === "Make") vehicle.make = segments[index + 1];
      if (segment === "Model") vehicle.model = segments[index + 1];
    });

    if (!vehicle.year || !vehicle.make || !vehicle.model) return null;
    return vehicle;
  }

  var VEHICLE_STORAGE_KEY = "cm_selected_vehicle";

  function persistVehicle(vehicle) {
    try {
      localStorage.setItem(VEHICLE_STORAGE_KEY, JSON.stringify(vehicle));
    } catch (e) {}
  }

  function loadPersistedVehicle() {
    try {
      var raw = localStorage.getItem(VEHICLE_STORAGE_KEY);
      if (!raw) return null;
      var vehicle = JSON.parse(raw);
      if (!vehicle || !vehicle.year || !vehicle.make || !vehicle.model) return null;
      return vehicle;
    } catch (e) {
      return null;
    }
  }

  function initPanel(panel, options) {
    if (!panel || panel.hasAttribute("data-cm-vehicle-initialized")) return;

    options = options || {};

    var yearSelect = panel.querySelector('select[data-index="1"]');
    var makeSelect = panel.querySelector('select[data-index="2"]');
    var modelSelect = panel.querySelector('select[data-index="3"]');
    if (!yearSelect || !makeSelect || !modelSelect) return;

    panel.setAttribute("data-cm-vehicle-initialized", "1");

    var yearPlaceholder = yearSelect.getAttribute("aria-label") || "Year";
    var makePlaceholder = makeSelect.getAttribute("aria-label") || "Make";
    var modelPlaceholder = modelSelect.getAttribute("aria-label") || "Model";

    var form = panel.closest("form");
    var submitButton = form ? form.querySelector('button[type="submit"]') : null;

    function isPanelActive() {
      return panel.classList.contains("is-active") && !panel.hasAttribute("hidden");
    }

    function updateSubmitState() {
      if (!submitButton || !isPanelActive()) return;
      submitButton.disabled = !(yearSelect.value && makeSelect.value && modelSelect.value);
    }

    function loadYears(pending) {
      fetch(buildFacetUrl([{ name: "Year" }]))
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          var facet = findFacet(data.Facets, "Year");
          if (!facet) return;

          clearSelect(yearSelect, yearPlaceholder);
          populateSelect(yearSelect, facet.Values);
          enableSelect(yearSelect);

          if (pending && pending.year && setSelectValueByTerm(yearSelect, pending.year)) {
            loadMakes(yearSelect.value, pending);
          }
        })
        .catch(function () {});
    }

    function loadMakes(year, pending) {
      disableSelect(makeSelect, makePlaceholder);
      disableSelect(modelSelect, modelPlaceholder);
      updateSubmitState();

      fetch(buildFacetUrl([{ name: "Year", selection: year }, { name: "Make" }]))
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          var facet = findFacet(data.Facets, "Make");
          if (!facet) return;

          clearSelect(makeSelect, makePlaceholder);
          populateSelect(makeSelect, facet.Values);
          enableSelect(makeSelect);

          if (pending && pending.make && setSelectValueByTerm(makeSelect, pending.make)) {
            loadModels(year, makeSelect.value, pending);
          }
        })
        .catch(function () {});
    }

    function loadModels(year, make, pending) {
      disableSelect(modelSelect, modelPlaceholder);
      updateSubmitState();

      fetch(
        buildFacetUrl([
          { name: "Year", selection: year },
          { name: "Make", selection: make },
          { name: "Model" },
        ])
      )
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          var facet = findFacet(data.Facets, "Model");
          if (!facet) return;

          clearSelect(modelSelect, modelPlaceholder);
          populateSelect(modelSelect, facet.Values);
          enableSelect(modelSelect);

          if (pending && pending.model && setSelectValueByTerm(modelSelect, pending.model)) {
            updateSubmitState();
          }
        })
        .catch(function () {});
    }

    yearSelect.addEventListener("change", function () {
      updateSubmitState();
      if (!yearSelect.value) return;
      loadMakes(yearSelect.value);
    });

    makeSelect.addEventListener("change", function () {
      updateSubmitState();
      if (!makeSelect.value) return;
      loadModels(yearSelect.value, makeSelect.value);
    });

    modelSelect.addEventListener("change", updateSubmitState);

    if (form) {
      var tabs = form.querySelectorAll(".filter-tab");
      tabs.forEach(function (tab) {
        tab.addEventListener("click", updateSubmitState);
      });

      form.addEventListener(
        "submit",
        function (event) {
          if (!isPanelActive()) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          var year = yearSelect.value;
          var make = makeSelect.value;
          var model = modelSelect.value;
          if (!year || !make || !model) return;

          var yearTerm = yearSelect.selectedOptions[0].dataset.term;
          var makeTerm = makeSelect.selectedOptions[0].dataset.term;
          var modelTerm = modelSelect.selectedOptions[0].dataset.term;

          var vehicle = { year: yearTerm, make: makeTerm, model: modelTerm };
          persistVehicle(vehicle);

          if (typeof options.onSubmit === "function") {
            options.onSubmit(vehicle);
            return;
          }

          window.location =
            "/pages/search?Fitment/Vehicle-Specific/Year/" +
            encodeURIComponent(yearTerm) +
            "/Make/" +
            encodeURIComponent(makeTerm) +
            "/Model/" +
            encodeURIComponent(modelTerm);
        },
        true
      );
    }

    loadYears(parseVehicleFromUrl() || loadPersistedVehicle());
  }

  function init() {
    document
      .querySelectorAll('.filter-tab-panel[id$="-vehicle"]:not(#header-filter-panel-vehicle)')
      .forEach(initPanel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.cmInitVehiclePanel = initPanel;
})();
